class FJFacetsModal {
  constructor() {
    this.modal = document.getElementById('fj-facets-modal');
    this.modalBody = document.getElementById('fj-facets-modal-body');
    this.trigger = document.getElementById('fj-mobile-filter-trigger');

    if (!this.modal || !this.trigger) return;

    this.sidebar = document.getElementById('fj-facets-container');
    this.toolbarSortContainer = document.getElementById('fj-facets-sort-container');

    this.trigger.addEventListener('click', this.open.bind(this));

    this.modal.querySelectorAll('[data-facets-modal-close]').forEach((el) => {
      el.addEventListener('click', this.close.bind(this));
    });

    const applyButton = this.modal.querySelector('[data-facets-modal-apply]');
    if (applyButton) {
      applyButton.addEventListener('click', this.applyAndClose.bind(this));
    }

    this.modalBody.addEventListener('click', this.onAccordionClick.bind(this));
  }

  applyAndClose() {
    const facetsEl = document.querySelector('fj-facets');
    if (facetsEl && typeof facetsEl.applyFilters === 'function') {
      facetsEl.applyFilters();
    }
    this.close();
  }

  onAccordionClick(event) {
    const summary = event.target.closest('summary');
    if (!summary) return;
    const clickedGroup = summary.closest('.fj-facet-group');
    if (!clickedGroup) return;
    requestAnimationFrame(() => {
      this.modalBody.querySelectorAll('.fj-facet-group').forEach((group) => {
        if (group !== clickedGroup) group.removeAttribute('open');
      });
    });
  }

  open() {
    if (this.toolbarSortContainer) this.modalBody.appendChild(this.toolbarSortContainer);
    if (this.sidebar) this.modalBody.appendChild(this.sidebar);

    this.modalBody.querySelectorAll('.fj-facet-group').forEach((group) => {
      group.removeAttribute('open');
    });

    const sortGroup = this.toolbarSortContainer ? this.toolbarSortContainer.querySelector('.fj-facet-group') : null;
    if (sortGroup) sortGroup.setAttribute('open', '');

    this.modal.classList.add('fj-facets-modal--open');
    document.body.classList.add('fj-scroll-lock');
  }

  close() {
    const sortGroup = this.toolbarSortContainer ? this.toolbarSortContainer.querySelector('.fj-facet-group') : null;
    if (sortGroup) sortGroup.removeAttribute('open');

    if (this.sidebar) {
      this.sidebar.querySelectorAll('.fj-facet-group').forEach((group) => {
        group.setAttribute('open', '');
      });
    }

    if (this.toolbarSortContainer) document.querySelector('.fj-collection-toolbar').appendChild(this.toolbarSortContainer);
    if (this.sidebar) document.querySelector('.fj-collection-sidebar').appendChild(this.sidebar);

    this.modal.classList.remove('fj-facets-modal--open');
    document.body.classList.remove('fj-scroll-lock');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new FJFacetsModal();
});